export function toCamelCase(str: string): string {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function convertKeysToCamelCase<T>(obj: T): T {
    if (Array.isArray(obj)) {
        // Recursively process each element in the array
        return obj.map(item => convertKeysToCamelCase(item)) as unknown as T;
    }
 
    if (obj !== null && typeof obj === 'object') {
        const result: Record<string, any> = {};
   
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const camelCaseKey = toCamelCase(key); // Convert PascalCase key to camelCase
                result[camelCaseKey] = convertKeysToCamelCase((obj as any)[key]); // Recursively process nested objects or arrays
            }
        }
   
        return result as T; // Cast back to the type of the original object
    }
 
    return obj; // Return primitive values as is
}